import type { IconName } from "@similarweb/icons";

import { translate } from "app/filters/i18nFilter";

export enum ESerpTypes {
    featured_snippet = "featured_snippet",
    related_questions = "related_questions",
    knowledge = "knowledge",
    paid = "paid",
    tiktok_carousel = "tiktok_carousel",
    twitter = "twitter",
    video = "video",
    images = "images",
    sitelinks = "sitelinks",
    instant_answers = "instant_answers",
    pla = "pla",
    products_grid = "products_grid",
    popular_products = "popular_products",
    local_pack = "local_pack",
    hotels = "hotels",
    news = "news",
    flights = "flights",
    recipes = "recipes",
    jobs = "jobs",
    stock_answer = "stock_answer",
    things_to_know = "things_to_know",
    related_searches = "related_searches",
    people_also_search_for = "people_also_search_for",
    transit = "transit",
    discussions_and_forums = "discussions_and_forums",
    local_services = "local_services",
    app = "app",
    short_videos = "short_videos",
    ai_overview = "ai_overview",
}

interface ISerpFeatureProps {
    icon: IconName;
    name: string;
    id: ESerpTypes | string;
}

export interface ISerpFeaturesMap {
    [key: string]: ISerpFeatureProps;
}

export const SERP_FEATURES_MAP: ISerpFeaturesMap = {
    [ESerpTypes.ai_overview]: {
        icon: "spark-ai",
        id: ESerpTypes.ai_overview,
        get name() {
            return translate("RT.filters.SERP.ai_overview");
        },
    },
    [ESerpTypes.featured_snippet]: {
        icon: "opportunities",
        id: ESerpTypes.featured_snippet,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.featured_Snippet");
        },
    },
    [ESerpTypes.related_questions]: {
        icon: "questions",
        id: ESerpTypes.related_questions,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.related_questions");
        },
    },
    [ESerpTypes.knowledge]: {
        icon: "helpcenter",
        id: ESerpTypes.knowledge,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.knowledge");
        },
    },
    [ESerpTypes.paid]: {
        icon: "serp-paid",
        id: ESerpTypes.paid,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.paid");
        },
    },
    [ESerpTypes.tiktok_carousel]: {
        icon: "ticktok",
        id: ESerpTypes.tiktok_carousel,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.tiktok_carousel");
        },
    },
    [ESerpTypes.twitter]: {
        icon: "social-twitter",
        id: ESerpTypes.twitter,
        get name() {
            return translate("serp.feature.twitter");
        },
    },
    [ESerpTypes.video]: {
        icon: "video",
        id: ESerpTypes.video,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.video");
        },
    },
    [ESerpTypes.images]: {
        icon: "image",
        id: ESerpTypes.images,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.images");
        },
    },
    [ESerpTypes.sitelinks]: {
        icon: "serp-paid-with-links",
        id: ESerpTypes.sitelinks,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.sitelinks");
        },
    },
    [ESerpTypes.instant_answers]: {
        icon: "direct",
        id: ESerpTypes.instant_answers,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.instant_answers");
        },
    },
    [ESerpTypes.pla]: {
        icon: "pla",
        id: ESerpTypes.pla,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.pla");
        },
    },
    [ESerpTypes.products_grid]: {
        icon: "serp_product_grid",
        id: ESerpTypes.products_grid,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.products_grid");
        },
    },
    [ESerpTypes.popular_products]: {
        icon: "nav-publishers",
        id: ESerpTypes.popular_products,
        get name() {
            return translate("serp.feature.popular_products");
        },
    },
    [ESerpTypes.local_pack]: {
        icon: "location",
        id: ESerpTypes.local_pack,
        get name() {
            return translate("serp.feature.local_pack");
        },
    },
    [ESerpTypes.hotels]: {
        icon: "hotels",
        id: ESerpTypes.hotels,
        get name() {
            return translate("serp.feature.hotels");
        },
    },
    [ESerpTypes.news]: {
        icon: "serp-news",
        id: ESerpTypes.news,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.news");
        },
    },
    [ESerpTypes.flights]: {
        icon: "flights",
        id: ESerpTypes.flights,
        get name() {
            return translate("serp.feature.flights");
        },
    },
    [ESerpTypes.recipes]: {
        icon: "recipes",
        id: ESerpTypes.recipes,
        get name() {
            return translate("serp.feature.recipes");
        },
    },
    [ESerpTypes.jobs]: {
        icon: "employees",
        id: ESerpTypes.jobs,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.jobs");
        },
    },
    [ESerpTypes.stock_answer]: {
        icon: "serp_stock",
        id: ESerpTypes.stock_answer,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.stock_answer");
        },
    },
    [ESerpTypes.things_to_know]: {
        icon: "serp_things_to_know",
        id: ESerpTypes.things_to_know,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.things_to_know");
        },
    },
    [ESerpTypes.related_searches]: {
        icon: "nav-keyword-group",
        id: ESerpTypes.related_searches,
        get name() {
            return translate("serp.feature.related_searches");
        },
    },
    [ESerpTypes.people_also_search_for]: {
        icon: "serp_people_ask",
        id: ESerpTypes.people_also_search_for,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.people_also_search_for");
        },
    },
    [ESerpTypes.transit]: {
        icon: "transit",
        id: ESerpTypes.transit,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.transit");
        },
    },
    [ESerpTypes.discussions_and_forums]: {
        icon: "discussions-and-forums",
        id: ESerpTypes.discussions_and_forums,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.discussions_and_forums");
        },
    },
    [ESerpTypes.local_services]: {
        icon: "local-services-ads",
        id: ESerpTypes.local_services,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.local_services_ads");
        },
    },
    [ESerpTypes.app]: {
        icon: "serp_product_grid",
        id: ESerpTypes.app,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.apps_pack");
        },
    },
    [ESerpTypes.short_videos]: {
        icon: "play",
        id: ESerpTypes.short_videos,
        get name() {
            return translate("SEO.keywordsCampaigns.keywordsReport.filters.SERP.short_videos");
        },
    },
};

export enum ESerpGroups {
    featuresOnSerp,
    featuresNotOnSerp,
    mainSiteFeaturesOnSerp,
    mainSiteFeaturesNotOnSerp,
}

export const MAP_GROUP_TO_CHIPDOWN_TEXT = {
    [ESerpGroups.featuresOnSerp]: "SEO.keywordsCampaigns.keywordsReport.filters.group.onSerp.text",
    [ESerpGroups.featuresNotOnSerp]: "SEO.keywordsCampaigns.keywordsReport.filters.group.notOnSerp.text",
    [ESerpGroups.mainSiteFeaturesOnSerp]: "SEO.keywordsCampaigns.keywordsReport.filters.group.ranks.text",
    [ESerpGroups.mainSiteFeaturesNotOnSerp]: "SEO.keywordsCampaigns.keywordsReport.filters.group.notRank.text",
};
export const MAP_GROUP_TO_CHIPDOWN_TOOLTIP = {
    [ESerpGroups.featuresOnSerp]: "SEO.keywordsCampaigns.keywordsReport.filters.group.onSerp.tooltip",
    [ESerpGroups.featuresNotOnSerp]: "SEO.keywordsCampaigns.keywordsReport.filters.group.notOnSerp.tooltip",
    [ESerpGroups.mainSiteFeaturesOnSerp]: "SEO.keywordsCampaigns.keywordsReport.filters.group.ranks.tooltip",
    [ESerpGroups.mainSiteFeaturesNotOnSerp]: "SEO.keywordsCampaigns.keywordsReport.filters.group.notRank.tooltip",
};

export interface ISERPFilterValue {
    selectedSerpTypesIDs: ESerpTypes[];
    selectedGroup: ESerpGroups;
}

export const DEFAULT_SELECT_SERP_GROUP = 0;
